<template>
  <header :class="[is_home ? 'g-header g-header-home' : 'g-header']">
    <div class="g-box">
      <h1 v-if="is_home" class="g-header_logo">
        <span class="g-clip">{{ $t("Site.header01") }}</span>
        <img class="g-pc" :src="this.$i18n.locale == 'en' ? '/img/logo-text-en.svg' : '/img/logo-text.svg'" alt="">
        <img class="g-sp" :src="this.$i18n.locale == 'en' ? '/img/logo-text-en.png' : '/img/logo-text.png'" alt="">
      </h1>
      <p v-else class="g-header_logo">
        <router-link :to="'/' | lang">
          <span class="g-clip">{{ $t("Site.header01") }}</span>
          <img class="g-pc" :src="this.$i18n.locale == 'en' ? '/img/logo-text-en.svg' : '/img/logo-text.svg'" alt="">
          <img class="g-sp" :src="this.$i18n.locale == 'en' ? '/img/logo-text-en.png' : '/img/logo-text.png'" alt="">
        </router-link>
      </p>
      <p class="g-header_lang"><router-link :to="this.transPath">{{ this.transLang }}</router-link></p>
    </div>
  </header>
</template>

<script>
import i18n from '@/i18n.js'

export default {
  filters: {
    // 英語ページの場合は英語ページへのリンクにする
    lang (path) {
      return i18n.locale == 'en' ? '/en'+path : path
    }
  },
  computed: {
    transPath () {
      if (i18n.locale == 'en') {
        let fullpath = this.$route.fullPath.match(/\/en(.*)/)[1]
        if (!fullpath) {
          fullpath = '/'
        }
        return fullpath
      } else {
        let fullpath = this.$route.fullPath
        if (!fullpath) {
          fullpath = ''
        }
        return '/en'+fullpath
      }
    },
    transLang () {
      return i18n.locale == 'en' ? '日本語' : 'ENGLISH'
    },
    is_home () {
      return (this.transPath === '/' || this.transPath === '/en/') ? true : false
    }
  }
}
</script>
